<mat-tab-group>
  <mat-tab label="Dettaglio">
    <div class="component-wrapper">
      <div class="middle-title">
        <div
          class="middle-title-title">{{ entityId ? 'Dettaglio' : 'Creazione' }} {{ MachineTranslations.entityName }} {{ entityId }}
        </div>
        <div class="middle-title-actions">
          <button mat-stroked-button (click)="goBack()">Indietro</button>
          <button *ngIf="isMachineDeleted()" mat-raised-button color="accent" (click)="restore()">Ripristina</button>
          <button *ngIf="!isMachineDeleted()" type="submit" mat-raised-button color="primary" (click)="confirm()">Salva</button>
        </div>
      </div>
      <form class="group-form" *ngIf="groupControl">
        <mat-label>Gruppo</mat-label>
        <mat-form-field class="full-width base-component" appearance="outline">
          <input type="text"
                 placeholder="Seleziona o inserisci"
                 matInput
                 [formControl]="groupControl"
                 [matAutocomplete]="auto">
          <button
            (click)="groupControl.reset()"
            *ngIf="groupControl.value"
            aria-label="Clear"
            class="mat-mdc-select-search-clear"
            mat-button
          >
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            @for (group of filteredGroups | async; track group) {
              <mat-option [value]="group">{{ group }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </form>
      <div class="installation-type" *ngIf="machine">
        <mat-label>Tipo di installazione</mat-label>
        <mat-form-field class="full-width base-component" appearance="outline">
          <mat-select [(ngModel)]="installationType">
            <mat-option value="projector">Proiettore</mat-option>
            <mat-option value="monitor">Monitor</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <lib-dynamic-form
        #dynamicForm
        [forms]="forms"
        (send)="save($event)"
        [showButtonAndEmit]="false"
        [showConfirmationDialog]="false"
      ></lib-dynamic-form>
      <ng-container *ngIf="currentAssociationIds.length > 0">
        <p class="associated-machines-table-title">Macchine associate</p>
        <lib-full-table
          [actions]="machineTableActions"
          [columnList]="machineTableColumnList"
          [search]="machineTableSearch"
          [pageSize]="10"
          path="machine"
          [enableExport]="true"
          [join]="machineTableJoin"
          [quickSearchColumns]="machineTableQuickSearchColumns"
          [hideQuickSearchBar]="false"
          [includeDeleted]="true">
        </lib-full-table>
      </ng-container>
    </div>

  </mat-tab>
  @if (machine && (([AlmaboxPermissions.requestRead] | hasPermission | async))) {
    <mat-tab label="Richieste">
      <div class="component-wrapper">
        <div class="middle-title">Richieste</div>
        <lib-frame-entity-table
          entityName="request"
          [actionsEnabled]="false"
          [search]="requestTableSearch"
          [join]="requestTableJoin"
          [columnList]="requestTableColumnList"
        >
        </lib-frame-entity-table>
      </div>
    </mat-tab>
  }
  <mat-tab label="Scheduler" *ngIf="machine && !isMachineDeleted()">
    <div class="component-wrapper">
      <div class="middle-title">
        <div class="middle-title-title">Scheduler</div>
        <div class="middle-title-actions">
          <button
            type="submit"
            mat-raised-button
            color="primary"
            (click)="saveSchedulerConfig()"
            [disabled]="!hasSchedulerConfigChanged()"
          >Salva
          </button>
          <span
            [matTooltip]="hasSchedulerConfigChanged() ? 'Salva le modifiche pendenti alla configurazione dello scheduler' : ''">
                        <button
                          mat-raised-button
                          color="accent"
                          (click)="downloadSchedulerConfig()"
                          [disabled]="hasSchedulerConfigChanged()"
                          *ngIf="originalSchedulerConfigEnabled"
                        >Download</button>
                    </span>
        </div>
      </div>
      <app-machine-scheduler
        [(schedulerEnabled)]="machine.schedulerEnabled"
        [schedulerConfig]="machine.schedulerConfig"
      ></app-machine-scheduler>
    </div>
  </mat-tab>
  <mat-tab label="Comandi" *ngIf="machine && !isMachineDeleted()">
    <app-machine-commands [installationType]="machine.schedulerConfig?.installation_type"></app-machine-commands>
  </mat-tab>

</mat-tab-group>
